import { Link } from 'react-router-dom';
import type { ComicData } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicData;
  showRank?: number;
}

export default function ComicCard({ comic, showRank }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 漫画免费韩漫在线阅读`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {showRank && (
          <div className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center bg-primary-500 text-white font-bold text-sm rounded-br-lg">
            {showRank}
          </div>
        )}
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-foreground-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-accent-500 flex items-center gap-0.5">
            <i className="ri-star-fill text-[10px]"></i>
            {comic.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}